import { createContext, useReducer } from "react"

export const ApiContext = createContext()

export const employeeReducer = (state, action) => {
    switch (action.type) {
        case "GET_EMPLOYEES":
            return { ...state, employee: action.payload }
        case "POST_EMPLOYEE":
            return { ...state, employee: [...state.employee, action.payload] }
        case "PUT_EMPLOYEE":
            const filterdata = state.employee.filter(x => x.id !== action.payload.id)
            return { ...state, employee: [...filterdata, action.payload] }
        case "DELETE_EMPLOYEE":
            const updateddata = state.employee.filter(x => x.id !== action.payload)
            return { ...state, employee: updateddata }
        default:
            return state
    }
}

export const projectReducer = (state, action) => {
    switch (action.type) {
        case "GET_PROJECTS":
            return { ...state, projects: action.payload }
        case "POST_PROJECT":
            return { ...state, projects: [...state.projects, action.payload] }
        case "PUT_PROJECT":
            const filterdata = state.projects.filter(x => x.id !== action.payload.id)
            return { ...state, projects: [...filterdata, action.payload] }
        case "DELETE_PROJECT":
            const getdata = state.projects.filter(x => x.id !== action.payload.id)
            return { ...state, projects: getdata }
    }
}

export const invoiceReducer = (state, action) => {
    switch (action.type) {
        case "GET_INVOICES":
            return { ...state, invoices: action.payload }
        case "GET_INVOICE":
            return { ...state, invoicesinge: action.payload }
        case "POST_INVOICE":
            return { ...state, invoices: [...state.invoices, action.payload], barcode: action.payload.qRValue }
        case "PUT_INVOICE":
            const filterdata = state.invoices.filter(x => x.id !== action.payload.id)
            return { ...state, invoices: [...filterdata, action.payload], barcode: action.payload.qRValue }
        case "DELETE_INVOICE":
            const getdata = state.invoices.filter(x => x.id !== action.payload)
            return { ...state, invoices: getdata }
    }
}

export const salaryReducer = (state, action) => {
    switch (action.type) {
        case "GET_SALARIES":
            return { ...state, salaries: action.payload }
        case "POST_SALARY":
            return { ...state, salaries: [...state.salaries, action.payload] }
        case "DELETE_SALARY":
            const getdata = state.salaries.filter(x => x.id !== action.payload)
            return { ...state, salaries: getdata }
    }
}

export const businessReducer = (state, action) => {
    switch (action.type) {
        case "GET_BUSINESSES":
            return { ...state, businesses: action.payload }
        case "POST_BUSINESS":
            return { ...state, businesses: [...state.businesses, action.payload] }
        case "PUT_BUSINESS":
            const filterdata = state.businesses.filter(x => x.id !== action.payload.id)
            console.log("filterdata", filterdata);
            return { ...state, businesses: [...filterdata, action.payload] }
        case "DELETE_BUSINESS":
            const getdata = state.businesses.filter(x => x.id !== action.payload.id)
            return { ...state, businesses: getdata }
    }
}

export const invoiceItemReducer = (state, action) => {
    switch (action.type) {
        case "ADD_ITEMS":
            return { ...state, items: [...state.items, action.payload] }
        case "DELETE_ITEMS":
            return { ...state, items: action.payload }
        case "EMPTY_ITEMS":
            return { state, items: action.payload }

    }
}


export const demandLetterItemReducer = (state, action) => {
    switch (action.type) {
        case "ADD_DEMANDITEMS":
            return { ...state, demandletteritems: [...state.demandletteritems, action.payload] }
        case "DELETE_DEMANDITEMS":
            return { ...state, demandletteritems: action.payload }
        case "EMPTY_DEMANDITEMS":
            return { state, demandletteritems: action.payload }

    }
}

export const logisticsItemReducer = (state, action) => {
    switch (action.type) {
        case "ADD_LOGISTICSITEMS":
            return { ...state, logisticsitems: [...state.logisticsitems, action.payload] }
        case "DELETE_LOGISTICSITEMS":
            return { ...state, logisticsitems: action.payload }
        case "EMPTY_LOGISTICSITEMS":
            return { state, logisticsitems: action.payload }

    }
}

export const expenseReducer = (state, action) => {
    switch (action.type) {
        case "GET_EXPENSES":
            return { ...state, expenses: action.payload }
        case "POST_EXPENSE":
            return { ...state, expenses: [...state.expenses, action.payload] }
        case "PUT_EXPENSE":
            const filterdata = state.expenses.filter(x => x.id !== action.payload.id)
            return { ...state, expenses: [...filterdata, action.payload] }
        case "DELETE_EXPENSE":
            const updateddata = state.expenses.filter(x => x.id !== action.payload)
            console.log("from expense context", updateddata);
            return { ...state, expenses: updateddata }
    }
}

export const clientReducer = (state, action) => {
    switch (action.type) {
        case "GET_CLIENTS":
            return { ...state, clients: action.payload }
        case "ADD_CLIENTS":
            return { ...state, clients: [...state.clients, action.payload] }
        case "PUT_CLIENTS":
            const filterdata = state.clients.filter(x => x.id !== action.payload.id)
            return { ...state, clients: [...filterdata, action.payload] }
        case "DELETE_CLIENT":
            const getdata = state.clients.filter(x => x.id !== action.payload.id)
            return { ...state, clients: getdata }
    }
}

export const expensecategoryReducer = (state, action) => {
    switch (action.type) {
        case "GET_EXPENSECATEGORIES":
            return { ...state, expensecategories: action.payload }
        case "POST_EXPENSECATEGORY":
            return { ...state, expensecategories: [...state.expensecategories, action.payload] }
        case "PUT_EXPENSECATEGORY":
            const filterdata = state.expensecategories.filter(x => x.id !== action.payload.id)
            return { ...state, expensecategories: [...filterdata, action.payload] }
    }
}

export const loginReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            return { ...state, user: action.payload }
        case "LOGOUT":
            return { state, user: action.payload }
        case "GET_CURRENT_USER":
            return { ...state, user: action.payload }
        case "LOGOUT":
            return { ...state, user: action.payload }
    }
}

export const userReducer = (state, action) => {
    switch (action.type) {
        case "GET_USERS":
            return { ...state, users: action.payload }
        case "REGISTER_USER":
            return { ...state, users: [...state.users, action.payload] }
    }
}

export function ApiContextProvider({ children }) {
    const [state, employeedispatch] = useReducer(employeeReducer, {
        employee: []
    })

    const [projectState, projectdispatch] = useReducer(projectReducer, {
        projects: []
    })

    const [InvoiceState, invoicedispatch] = useReducer(invoiceReducer, {
        invoices: [],
        barcode: '',
        invoicesinge: {}
    })

    const [SalaryState, salarydispatch] = useReducer(salaryReducer, {
        salaries: []
    })

    const [BusinessState, businessdispatch] = useReducer(businessReducer, {
        businesses: []
    })
    const [expenseState, expensedispatch] = useReducer(expenseReducer, {
        expenses: []
    })

    const [InvoiceItemState, invoiceItemdispatch] = useReducer(invoiceItemReducer, {
        items: []
    })

    const [DemandLetterItemState, demandLetterItemdispatch] = useReducer(demandLetterItemReducer, {
        demandletteritems: []
    })

    const [logisticsItemState, logisticsItemdispatch] = useReducer(logisticsItemReducer, {
        logisticsitems: []
    })

    const [clientState, clientdispatch] = useReducer(clientReducer, {
        clients: []
    })

    const [expenseCategoryState, expensecategorydispatch] = useReducer(expensecategoryReducer, {
        expensecategories: []
    })

    const [loginState, logindispatch] = useReducer(loginReducer, {
        user: {}
    })

    const [userState, userdispatch] = useReducer(userReducer, {
        users: []
    })

    return (
        <ApiContext.Provider value={{
            ...state, employeedispatch,
            ...projectState, projectdispatch,
            ...InvoiceState, invoicedispatch,
            ...SalaryState, salarydispatch,
            ...BusinessState, businessdispatch,
            ...InvoiceItemState, invoiceItemdispatch,
            ...clientState, clientdispatch,
            ...expenseState, expensedispatch,
            ...expenseCategoryState, expensecategorydispatch,
            ...DemandLetterItemState, demandLetterItemdispatch,
            ...logisticsItemState, logisticsItemdispatch,
            ...loginState, logindispatch,
            ...userState, userdispatch
        }}>
            {children}
        </ApiContext.Provider>
    )

}